/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * FileUploadArea
 *
 */

import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Space, Text, Button, Conditional } from '@cashfree-intl/coherent';

import CustomIcons from 'components/CustomIcons';

import { getUploadedFileType } from './utils';

function FileUploadArea({
  checkList,
  id,
  accept = '',
  onChange,
  onDrop,
  resetUpload,
  disabled,
  previewFile,
  fileError,
  uploadedFile = {},
  uploadBtnContent = 'Upload',
  errorBorder = false,
}) {
  const [dragOver, setDragOver] = useState(false);
  const uploaded = uploadedFile && uploadedFile.name;

  const stopDefault = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragOver = e => {
    stopDefault(e);
    if (onDrop && !disabled && !dragOver) setDragOver(true);
  };

  const handleDragLeave = e => {
    stopDefault(e);
    if (onDrop && !disabled && dragOver) setDragOver(false);
  };

  const handleDrop = e => {
    stopDefault(e);
    if (onDrop && !disabled) {
      setDragOver(false);
      onDrop(e);
    }
  };

  return (
    <Space
      name={id}
      className={`file-upload-area ${uploaded ? 'uploaded' : ''} ${
        dragOver ? 'drag-over' : ''
      } ${errorBorder ? 'error-border' : ''}`}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      {uploaded ? (
        <>
          <Space direction="column">
            <Space alignItems="center">
              <CustomIcons
                componentName="FILE_FORMAT"
                format={getUploadedFileType(uploadedFile)}
              />
              <Text
                variant="h16"
                className={`ml-2 file-name ${previewFile ? 'link' : ''}`}
                onClick={previewFile}
              >
                {uploaded ? uploadedFile.name : ''}
              </Text>
            </Space>
            <Conditional if={fileError}>
              <Text variant="b12" color="danger" className="ml-5">
                {fileError}
              </Text>
            </Conditional>
          </Space>
          <Conditional if={!disabled}>
            <div className="pointer" onClick={resetUpload}>
              <CustomIcons componentName="CLOSE" />
            </div>
          </Conditional>
        </>
      ) : (
        <>
          <div className="file-upload-input">
            <Button
              secondary
              as="label"
              htmlFor={id}
              size="small"
              icon={
                <CustomIcons
                  componentName="UPLOAD_CLOUD_SM"
                  color={disabled ? 'var(--DISABLED)' : ''}
                />
              }
              disabled={disabled}
              className={disabled ? 'disabled' : ''}
            >
              {uploadBtnContent}
            </Button>
            <input
              hidden
              name={id}
              type="file"
              id={id}
              accept={accept}
              onChange={onChange}
            />
          </div>
          <div className="file-upload-checklist">
            {checkList.map(check => (
              <Text
                key={check}
                variant="b12"
                color={disabled ? 'placeholder' : 'bodyLight'}
              >
                - {check}
              </Text>
            ))}
          </div>
        </>
      )}
    </Space>
  );
}

FileUploadArea.propTypes = {
  checkList: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  accept: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onDrop: PropTypes.func,
  resetUpload: PropTypes.func.isRequired,
  uploadedFile: PropTypes.object,
  disabled: PropTypes.bool,
  previewFile: PropTypes.func,
  uploadBtnContent: PropTypes.string,
  fileError: PropTypes.string,
  errorBorder: PropTypes.bool,
};

export default memo(FileUploadArea);
